var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list"},_vm._l((_vm.idList),function(_id){return _c('productdetail',{directives:[{name:"show",rawName:"v-show",value:(_id == _vm.ineer_id),expression:"_id == ineer_id"}],key:_id,attrs:{"id":_vm.ineer_id,"params":_vm.params}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d53c019","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/detail/productpage.vue
// module id = null
// module chunks = 